import classNames from "classnames";
import copy from "copy-to-clipboard";
import { useEffect, useState } from "react";
import RivalsButton from "rivals/components/shared/Button";
import CheckCircle from "rivals/components/shared/Icons/CheckCircle";
import { MILLISECONDS_PER_SECOND } from "rivals/shared/constants";
import styles from "./index.module.scss";
import strings from "./strings";
import type { OwnProps } from "./types";

const { defaultCopiedButtonText, defaultCopyButtonText } = strings;

const CopyToClipboardButton = ({
  buttonClassName = "",
  className = "",
  copiedButtonText,
  copyButtonText,
  data = "",
  icon,
  showIcon,
  restoreWaitTime,
  textToCopy,
  ...buttonProps
}: OwnProps): JSX.Element => {
  const [copied, setCopied] = useState<boolean>(false);
  const copyText = copyButtonText ? copyButtonText : defaultCopyButtonText;
  const copiedText = copiedButtonText
    ? copiedButtonText
    : defaultCopiedButtonText;

  useEffect(() => {
    if (restoreWaitTime && copied) {
      const timer = setTimeout(() => {
        setCopied(false);
      }, restoreWaitTime * MILLISECONDS_PER_SECOND);

      return (): void => clearTimeout(timer);
    }
  }, [copied]);

  const onCopyUrlToClipboard = (): void => {
    if (!copied && copy(textToCopy)) {
      setCopied(true);
    }
  };

  const sideIcon = icon ? (
    icon
  ) : (
    <CheckCircle fill={styles.bone} fillBg={styles.abyss} />
  );

  return (
    <div className={classNames(styles.wrapper, className)}>
      {showIcon && copied && sideIcon}
      <RivalsButton
        buttonText={copied ? copiedText : copyText}
        className={classNames(styles.copyButton, buttonClassName)}
        data={`${data}-copy-to-clipboard`}
        onClick={onCopyUrlToClipboard}
        {...buttonProps}
      />
    </div>
  );
};

export default CopyToClipboardButton;
